import React, { useContext, useEffect, useState } from 'react'
import { getAdminIdApi } from '../../Constants';
import { Context } from '../../Context/Context';
import NotificationContent from 'Components/Notifications/NotificationContent';
import Header from 'Components/Header/Header';

function AdminNotification() {
  const {userDetails, makeApiCallFunc, setSelectedMenuItem} = useContext(Context);
  const [adminUserId, setAdminUserId] = useState(null);
  useEffect(()=>{
    setSelectedMenuItem("3");
    if(userDetails.isAdminAssistant)
    {
      makeApiCallFunc(getAdminIdApi + "/" + userDetails._id,
        null,
        (data) => { setAdminUserId(data?.data) },
        (data) => console.log(data)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  return (
    <>
      <Header />
      <div className='flex col-span-6 w-full flex-col font-plexsans' style={{ background: '#f7f4ed', minHeight: 'calc(100vh - 64px)' }}>
        <div className='w-full max-w-[960px] mx-auto px-5 py-8 lg:px-10 lg:py-12'>
          <NotificationContent title="Notifications" adminUserId={adminUserId} />
        </div>
      </div>
    </>
  )
}

export default AdminNotification;
